import { observable } from 'mobx'
import { CommonHistoryLogRequest } from '../../requests/CommonHistoryLogRequest'

class ListHistoryLogStore {
  @observable list = []
  @observable isLoading = false
  @observable message = null

  getList = async documentCode => {
    this.isLoading = true

    try {
      var response = await CommonHistoryLogRequest.getList(documentCode)
      this.list = Array.isArray(response?.data) ? response.data : []
      this.message = this.list.length === 0 ? 'Không có lịch sử' : null
    } catch (error) {
      console.error('Error fetching history log:', error)
      this.list = []
      this.message = 'Có lỗi xảy ra khi tải lịch sử'
    } finally {
      this.isLoading = false
    }
  }

  clear = () => {
    this.list = []
    this.isLoading = false
    this.message = null
  }
}

export default new ListHistoryLogStore()
